import type { CSSProperties } from "react";
import type { SectionListItem } from "../shared/schemas";

const scheduleTypeHues: Record<string, number> = {
  LEC: 215,
  LAB: 150,
  TUT: 265,
  THS: 39,
  SEM: 188,
  WRK: 215,
  OTHER: 235,
};

const shadeLightness = [92, 86, 80, 74, 68, 62];

function hashText(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return hash;
}

export function getCourseSectionColorStyle(
  section: Pick<SectionListItem, "subject" | "courseNumber" | "sectionCode" | "scheduleType">,
): CSSProperties {
  const scheduleTypeCode = section.scheduleType.trim().toUpperCase() || "OTHER";
  const hue = scheduleTypeHues[scheduleTypeCode] ?? scheduleTypeHues.OTHER;
  const sectionKey = `${section.subject.trim().toUpperCase()}|${section.courseNumber.trim().toUpperCase()}|${section.sectionCode.trim().toUpperCase()}`;
  const lightness = shadeLightness[hashText(sectionKey) % shadeLightness.length];
  const saturation = scheduleTypeCode === "WRK" ? 28 : 78;
  const borderLightness = Math.max(lightness - 24, 34);
  const textColor = lightness <= 68 ? "hsl(0 0% 100%)" : `hsl(${hue} 64% 16%)`;

  return {
    backgroundColor: `hsl(${hue} ${saturation}% ${lightness}%)`,
    borderColor: `hsl(${hue} ${Math.max(saturation - 10, 20)}% ${borderLightness}%)`,
    color: textColor,
  };
}
